'use client';

import React, { useEffect, useState } from 'react';
import CarouselContainer from '@/components/ui/CarouselContainer/CarouselContainer';
const CardCarousel = CarouselContainer; // ponytail: preserve original name from molecules barrel
import {
  WhatIsYourConcern,
  ConcernCard as ConcernCardType,
  Treatment,
} from '@/types/components/whatIsYourConcern';

type Props = {
  data: Pick<WhatIsYourConcern, 'heading' | 'description'>;
  concerns: ConcernCardType[];
  onConcernChange?: (payload: {
    concernHeading?: string;
    treatments: Treatment[];
  }) => void;
  concernOverlayClassName?: string;
};

const ConcernsCarouselClient = ({ data, concerns, onConcernChange }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const activeConcern = concerns[activeIndex];
    const treatments = activeConcern?.treatments ?? [];

    onConcernChange?.({
      concernHeading: activeConcern?.heading?.content,
      treatments,
    });
  }, [activeIndex, concerns, onConcernChange]);

  if (!concerns.length) return null;

  const carouselData = {
    heading: data?.heading?.content || 'What is your concern?',
    description: data?.description?.content || '',
  };

  const carouselItems = concerns.map((item, index) => ({
    ...item,
    id: `concern-${index}`,
    title: item.heading?.content || 'Concern',
    image: {
      url:
        item.image?.urlDesktop || item.image?.urlMobile || item.imageUrl || '',
      title: item.heading?.content || 'Concern',
      description: item.heading?.content || 'Concern',
    },
    button: {
      content: item.button?.content || 'View Service',
    },
    slug: '#treatments',
  }));

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % concerns.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + concerns.length) % concerns.length);
  };

  return (
    <div
      data-testid="concerns-carousel-wrapper"
      className="relative mb-4 overflow-x-hidden lg:mb-5"
    >
      <CardCarousel
        data={carouselData}
        items={carouselItems}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        onNext={handleNext}
        onPrev={handlePrev}
      />
    </div>
  );
};

export default ConcernsCarouselClient;
